import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useStore, todayISO } from '../lib/store';
import { Field, inputCls, EASE } from '../components/Bits';

export default function Setup() {
  const { startReal, startDemo } = useStore();
  const navigate = useNavigate();
  const [coupleName, setCoupleName] = useState('');
  const [weddingDate, setWeddingDate] = useState('');
  const [budget, setBudget] = useState('');
  const [city, setCity] = useState('');
  const [err, setErr] = useState('');

  const submit = (e) => {
    e.preventDefault();
    if (!coupleName.trim() || !weddingDate) {
      setErr('Nama pasangan dan tanggal pernikahan wajib diisi.');
      return;
    }
    startReal({ coupleName: coupleName.trim(), weddingDate, budget: Number(budget) || 0, city: city.trim() });
    navigate('/app');
  };

  return (
    <div className="min-h-svh bg-ivory relative overflow-hidden">
      <div className="kawung absolute inset-0 opacity-[0.03] pointer-events-none" />
      <div className="relative mx-auto w-full max-w-md px-6 py-10">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: EASE }}>
          <Link data-testid="setup-back-home" to="/" className="flex items-center gap-2.5 mb-10">
            <span className="w-2.5 h-2.5 rotate-45 bg-terra" />
            <span className="font-serif text-lg font-semibold text-ink">SebelumSah<span className="text-terra">.</span></span>
          </Link>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-terra mb-3">Langkah pertama</p>
          <h1 className="font-serif text-3xl font-medium tracking-tight text-ink leading-tight">Sedikit tentang kalian berdua.</h1>
          <p className="mt-3 text-sm text-cashmere leading-relaxed">Hanya ini yang kami tanyakan. Tanpa akun, data tersimpan di perangkatmu. Sebelum sah, jangan asal pasrah. 😄</p>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <Field label="Nama pasangan">
              <input data-testid="setup-couple-input" className={inputCls} placeholder="Rani & Dimas" value={coupleName} onChange={(e) => setCoupleName(e.target.value)} />
            </Field>
            <Field label="Tanggal pernikahan">
              <input data-testid="setup-date-input" type="date" min={todayISO()} className={inputCls} value={weddingDate} onChange={(e) => setWeddingDate(e.target.value)} />
            </Field>
            <Field label="Estimasi budget" optional>
              <input data-testid="setup-budget-input" type="number" min="0" className={inputCls} placeholder="150000000" value={budget} onChange={(e) => setBudget(e.target.value)} />
            </Field>
            <Field label="Kota" optional>
              <input data-testid="setup-city-input" className={inputCls} placeholder="Bandung" value={city} onChange={(e) => setCity(e.target.value)} />
            </Field>
            {err && <p data-testid="setup-error" className="text-xs font-semibold text-amberw">{err}</p>}
            <button data-testid="setup-submit" type="submit" className="w-full rounded-full bg-ink text-ivory py-4 text-sm font-bold hover:bg-inkdeep transition-colors">
              Mulai SebelumSah <ArrowRight size={15} className="inline ml-1.5 -mt-0.5" />
            </button>
            <button
              data-testid="setup-demo-link"
              type="button"
              onClick={() => { startDemo(); navigate('/app'); }}
              className="w-full text-center text-xs font-semibold text-terra hover:underline"
            >
              atau coba dengan data demo
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}
